export { routeBankAccountsTree } from './bankAccountsRoutes'
